import { render, staticRenderFns } from "./EmailEditing.vue?vue&type=template&id=a16f99c8"
import script from "./EmailEditing.vue?vue&type=script&lang=js"
export * from "./EmailEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports